<template>
    <layout-card
        :error="error"
        :loading="loading"
        :type="settings.context"
        :isCustomizable="settings.isCustomizable"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
        class="card-order_staff"
        >

        <template #title>
            {{ name }}
        </template>
        <template #actions>
            <li v-if="settings.canCreate" class="dinlineb">
                <a href="javascript:;" @click="addAction"  class="p-0 py-1"><i class="icon-add hover-primary-50 gray-60"></i></a>
            </li>
        </template>
        <template #content>
            <template-kpi-card :data="{'stats': cardData, 'labels': labels}" />

            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>

        <template #footer>
            <fiscal-year-footer :fiscalYearTimestamp="fiscalYear"></fiscal-year-footer>
        </template>
    </layout-card>
</template>

<script>
    import LayoutCard from './LayoutCard.vue'
    import TemplateKpiCard from './TemplateKpiCard.vue'
    import CardMixin from './CardMixin.js';
    import FiscalYearFooter from './FiscalYearFooter.vue'

    export default {
        mixins : [CardMixin],
        data() {
            return {
                labels: {
                    accepted: {
                        label: this.$l10n.__("En attente de facturation"),
                        labelCount: this.$l10n.__("Bons de commande")
                    },
                    expired: {
                        label: this.$l10n.__("Expiré"),
                        labelCount: this.$l10n.__("Bons de commande")
                    }
                },
                settingsFormName : 'order-setting-form'
            }
        },
        methods : {
            addAction(){
                var title = this.$l10n.__('Créer un bon de commande');
                DocTools.createForThird('order', title);
            }
        },
        components: {
            LayoutCard,
            TemplateKpiCard,
            FiscalYearFooter,
        }
    }
</script>